import React from "react";

export const AboutSection = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-16 md:py-24 lg:py-28 bg-slate-50/60 border-y border-slate-100"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="text-xs tracking-[0.2em] text-[#65a30d] font-semibold uppercase">
          About Execora
        </div>

      <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-semibold text-slate-900 tracking-tight leading-[1.1]">
  Anything you need,{" "}
  <span className="text-[#65a30d]">Delivered!</span>
</h2>

        <p className="mt-6 text-slate-600 text-base sm:text-lg leading-relaxed max-w-3xl mx-auto">
         Neighbourhood shops and services still work offline and that makes them hard to access when we need them.
          Execora bridges that gap by connecting you to nearby vendors and handling the pickup and delivery.
        </p>

        <p className="mt-4 text-slate-600 text-base sm:text-lg leading-relaxed max-w-3xl mx-auto">
          
        </p>
      </div>
    </section>
  );
};

export default AboutSection;
